import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";
import { DatabaseFilled } from "@ant-design/icons";

export function* handleFetchOrders({ payload }) {
  try {
    const res = yield call(API.fetchOrderDetails, payload);
    const { data } = res;
    yield put(actions.fetchOrderDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchOrderDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchSampleDetails({ payload }) {
  try {
    const res = yield call(API.fetchSampleDetails, payload);
    const { data } = res;
    yield put(actions.fetchSampleDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchSampleDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchCommodities({ payload }) {
  try {
    const res = yield call(API.fetchAllCommodities, payload);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(API.fetchAllStates, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchDistricts({ payload }) {
  try {
    const res = yield call(API.fetchDistrictsForState, payload);
    const { data } = res;
    yield put(actions.fetchDistrictsSuccess(data));
  } catch (err) {
    yield put(actions.fetchDistrictsFailure(err?.response?.data));
  }
}

export function* handleFetchSamplers({ payload }) {
  try {
    const res = yield call(API.fetchSamplersForDistrict, payload);
    const { data } = res;
    yield put(actions.fetchSamplersSuccess(data));
  } catch (err) {
    yield put(actions.fetchSamplersFailure(err?.response?.data));
  }
}

export function* handlePurchaseOrderDownload({ payload }) {
  try {
    const { fileName } = payload.data;
    //const res = yield call(API.getDownloadUrl, payload);
    const res = yield call(API.getFileUrl, {
      blobName: fileName,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });
    const { data } = res;
    const file = yield call(API.downloadFile, {
      url: data.data.document,
      data: "",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(file.data);
    link.setAttribute("download", fileName);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    document.body.removeChild(link);
    yield put(actions.downloadFileSuccess({ id: payload.id }));
  } catch (err) {
    yield put(actions.downloadFileFailure({ id: payload.id, err }));
  }
}

export function* handleReportHardcopy({ payload }) {
  try {
    const res = yield call(API.requestReportHardCopy, payload);
    const { data } = res;
    yield put(actions.requestReportHardCopySuccess(data));
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.saveReportHardCopyFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.requestReportHardCopyFailure(err?.response?.data));
  }
}

export function* handleRaiseDispute({ payload }) {
  try {
    const res = yield call(API.raiseDispute, {
      id: payload.id,
      data: payload.payloadData.data,
    });
    const { data } = res;
    yield put(actions.raiseDisputeSuccess(data));
    if (payload.payloadData.onSuccess) payload.payloadData.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.raiseDisputeFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.raiseDisputeFailure(err?.response?.data));
    if (payload.payloadData.onFailure) payload.payloadData.onFailure();
  }
}

export function* handleUpdateLabsAndLogistics({ payload }) {
  try {
    const res = yield call(API.updateLabsAndLogistics, payload.data);
    const { data } = res;
    if (payload.onSuccess) {
      payload.onSuccess();
    }
    yield put(actions.updateLabsAndLogisticsSuccess(data));
  } catch (err) {
    yield put(actions.updateLabsAndLogisticsFailure(err?.response?.data));
  }
}

export function* handleAddGRN({ payload }) {
  const { id, orderId, grnNumber, grnFile, source, fileUsedFor, company } =
    payload.data;
  try {
    //file upload
    const res = yield call(API.getFileUrl, {
      fileName: grnFile.name,
      source: source,
      fileUsedFor: fileUsedFor,
      companyId: company,
      orderId: orderId,
    });
    const url = res.data?.data?.document;
    const formData = new FormData();
    formData.append("file", grnFile);
    const fileUploadRes = yield call(API.uploadFile, { data: formData, url });
    if (fileUploadRes.status !== 200) {
      throw new Error("Error uploading Purchase Order!");
    }
    const fileUploadedUrl = new URL(url);
    const pathName = fileUploadedUrl?.pathname.slice(1);
    const addGrnres = yield call(API.addGRNForOrder, {
      id: id,
      data: {
        grn: grnNumber,
        grnFile: pathName,
      },
    });
    const { data } = addGrnres;
    yield put(actions.addGRNSuccess(data));
    yield put(actions.fetchOrderDetails(id));
    if (payload.onSuccess) payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.addGRNFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.addGRNFailure(err?.response?.data));
    if (payload.onFailure) payload.onFailure();
  }
}

export function* handleUpdateGRN({ payload }) {
  const {
    id,
    orderId,
    grnNumber,
    grnFileRef,
    check,
    source,
    fileUsedFor,
    company,
  } = payload.data;
  let updateGrnres = null;
  try {
    if (check.updateGrnNumber) {
      updateGrnres = yield call(API.addGRNForOrder, {
        id: id,
        data: {
          grn: grnNumber,
        },
      });
    }
    if (check.updateGrnFile) {
      //file upload

      const res = yield call(API.getFileUrl, {
        fileName: grnFileRef.name,
        source: source,
        fileUsedFor: fileUsedFor,
        companyId: company,
        orderId: orderId,
      });
      const url = res.data?.data?.document;
      const formData = new FormData();
      formData.append("file", grnFileRef);
      const fileUploadRes = yield call(API.uploadFile, { data: formData, url });
      if (fileUploadRes.status !== 200) {
        throw new Error("Error uploading Purchase Order!");
      }
      const fileUploadedUrl = new URL(url);
      const pathName = fileUploadedUrl?.pathname.slice(1);
      updateGrnres = yield call(API.addGRNForOrder, {
        id: id,
        data: {
          grn: grnNumber,
          grnFile: pathName,
        },
      });
    }

    const { data } = updateGrnres;
    yield put(actions.updateGRNDetailsSuccess(data));
    yield put(actions.fetchOrderDetails(id));
    if (payload.onSuccess) payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.updateGRNDetailsFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateGRNDetailsFailure(err?.response?.data));
    if (payload.onFailure) payload.onFailure();
  }
}

export function* handleFetchCompanyFeatures({ payload }) {
  try {
    const res = yield call(API.fetchCompanyFeatures, payload);
    const { data } = res;
    yield put(actions.fetchCompanyFeaturesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyFeaturesFailure(err?.response?.data));
  }
}

export function* handleUpdateOrderStatus({ payload }) {
  try {
    const res = yield call(API.updateOrderStatus, payload.data);
    const { data } = res;

    if (payload.onSuccess) {
      payload.onSuccess();
    }
    yield put(actions.updateOrderStatusSuccess(data));
  } catch (err) {
    yield put(actions.updateOrderStatusFailure(err?.response?.data));
    if (payload.onFailure) {
      payload.onFailure(err?.response?.data?.document);
    }
  }
}

export function* handleFetchDropdown({ payload }) {
  try {
    const res = yield call(API.fetchDropdown, payload);
    const { data } = res;
    yield put(actions.fetchDropdownSuccess(data));
  } catch (err) {
    yield put(actions.fetchDropdownFailure(err?.response?.data));
  }
}

export function* handleFetchProjectCodes({ payload }) {
  try {
    const res = yield call(API.fetchAllProjectCodes, payload);
    const { data } = res;
    yield put(actions.fetchProjectCodesSuccess(data));
  } catch (err) {
    yield put(actions.fetchProjectCodesFailure(err?.response?.data));
  }
}

export function* handleCreateReplacementOrder({ payload }) {
  try {
    const res = yield call(API.createReplacementOrder, payload);
    const { data } = res;
    if (payload.onSuccess) {
      payload.onSuccess(data.data?.newOrder?._id);
    }
    yield put(actions.createReplacementOrderSuccess(data));
  } catch (err) {
    yield put(actions.createReplacementOrderFailure(err?.response?.data));
    if (payload.onFailure) {
      payload.onFailure(err?.response?.data);
    }
  }
}

export function* handleFetchCompanies({ payload }) {
  try {
    const res = yield call(API.fetchAllCompanies, payload);
    const { data } = res;
    yield put(actions.fetchCompaniesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompaniesFailure(err?.response?.data));
  }
}

export function* handleUpdateSampleDetails({ payload }) {
  try {
    const res = yield call(API.updateSampleDetails, payload);
    const { data } = res;
    if (payload.onSuccess) {
      payload.onSuccess({
        message: data?.message || "Sample details updated successfully!",
      });
    }
    yield put(actions.updateSampleDetailsSuccess(data));
  } catch (err) {
    console.error("Error in updateSampleDetails saga:", err?.response?.data);
    yield put(actions.updateSampleDetailsFailure(err?.response?.data));
    payload.onFailure(err?.response?.data);
  }
}

export function* handleRequestCorrection({ payload }) {
  try {
    const res = yield call(API.requestCorrection, payload);
    yield put(actions.requestCorrectionSuccess(res.data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.requestCorrectionFailure(err?.response?.data));
  }
}

export function* handleFetchComments({ payload }) {
  try {
    const res = yield call(API.fetchNeedCorrectionCommentsForOrder, payload);
    const { data } = res;

    // Extract document[].comments array
    const comments =
      data?.data?.document?.map((item) => ({
        comment: item.comments,
        date: item.createdAt,
      })) || [];

    yield put(actions.fetchCommentsSuccess(comments));
  } catch (err) {
    yield put(actions.fetchCommentsFailure(err?.response?.data));
  }
}

export function* handleFetchLabs({ payload }) {
  try {
    const res = yield call(API.fetchAllLabs, payload);
    const { data } = res;
    yield put(actions.fetchLabsSuccess(data));
  } catch (err) {
    yield put(actions.fetchLabsFailure(err?.response?.data));
  }
}

export function* handleFetchLogisticPartners({ payload }) {
  try {
    const res = yield call(API.fetchAllLogisticPartners, payload);
    const { data } = res;
    yield put(actions.fetchLogisticPartnersSuccess(data));
  } catch (err) {
    yield put(actions.fetchLogisticPartnersFailure(err?.response?.data));
  }
}

export function* handleAssignLabAndLogistic({ payload }) {
  try {
    if (!payload.same.isSameLab) {
      yield call(API.updateOrder, { data: payload.labData });
    }
    if (!payload.same.isSameLogistic || !payload.same.isSameTrackingId) {
      yield call(API.assignLogisticAndTrackingIdToOrder, payload.logisticData);
    }

    // // fetch updated order details
    const res = yield call(API.fetchOrderDetails, payload?.id);
    const { data } = res;
    yield put(actions.fetchOrderDetailsSuccess(data));

    yield put(actions.assignLabAndLogisticSuccess());
    payload.onSuccess();
  } catch (err) {
    yield put(actions.assignLabAndLogisticFailure(err?.response?.data));
    payload.onFailure(err?.response?.data);
  }
}

export function* handleFetchSectors({ payload }) {
  try {
    const res = yield call(API.getSectors, payload);
    const { data } = res;
    yield put(actions.fetchSectorsSuccess(data));
  } catch (err) {
    yield put(actions.fetchSectorsFailure(err?.response?.data));
  }
}

export function* handleFetchLabAnalyticsDetails({ payload }) {
  try {
    const res = yield call(API.getLabAnalyticsDetails, payload);
    const { data } = res;
    yield put(actions.fetchLabAnalyticsDetailsSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.fetchLabAnalyticsDetailsFailure(err?.response?.data));
    payload.onFailure(err?.response?.data);
  }
}

export function* handleUpdateOrderDocuments({ payload }) {
  try {
    const res = yield call(API.updateOrderDocuments, payload);
    const { data } = res;
    yield put(actions.updateOrderDocumentsSuccess(data));

    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.updateOrderDocumentsFailure());
    if (payload.onFailure) {
      payload.onFailure(err);
    }
  }
}

export function* handleFetchOrderCorrectionReasons({ payload }) {
  try {
    const res = yield call(API.fetchOrderCorrectionReasons, payload);
    const { data } = res;
    yield put(actions.fetchOrderCorrectionReasonsSuccess(data));

    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.fetchOrderCorrectionReasonsFailure());
    if (payload.onFailure) {
      payload.onFailure(err);
    }
  }
}

export function* handleRequestOrderCorrection({ payload }) {
  try {
    yield call(API.orderCorrectionRequest, payload);
    yield put(actions.requestOrderCorrectionSuccess());

    // // fetch updated order details
    const response = yield call(API.fetchOrderDetails, payload?.data?._id);
    const { data } = response;
    yield put(actions.fetchOrderDetailsSuccess(data));

    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.requestOrderCorrectionFailure());
    if (payload.onFailure) {
      payload.onFailure(err);
    }
  }
}

export function* handleFetchPackages({ payload }) {
  try {
    const res = yield call(API.fetchPackagesByCompanyAndCommodity, payload);
    const { data } = res;
    yield put(actions.fetchPackagesSuccess(data));
  } catch (err) {
    yield put(actions.fetchPackagesFailure(err?.response?.data));
  }
}

export function* handleUpdateOrderDetails({ payload }) {
  try {
    const res = yield call(API.updateOrderDetails, payload);
    const { data } = res;
    yield put(actions.updateOrderDetailsSuccess(data));

    // // fetch updated order details
    const response = yield call(API.fetchOrderDetails, payload?.data?._id);
    const { data: updatedData } = response;
    yield put(actions.fetchOrderDetailsSuccess(updatedData));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.updateOrderDetailsFailure(err?.response?.data));
    if (payload.onFailure) {
      payload.onFailure(err?.response?.data);
    }
  }
}

export function* handleFetchAgencies({ payload }) {
  try {
    const res = yield call(API.fetchAgencies, payload);
    const { data } = res;
    yield put(actions.fetchAgenciesSuccess(data));
  } catch (err) {
    yield put(actions.fetchAgenciesFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* orderDetailsSaga() {
  yield takeLatest(actions.fetchOrderDetails.type, handleFetchOrders);
  yield takeLatest(actions.fetchSampleDetails.type, handleFetchSampleDetails);
  yield takeLatest(actions.requestReportHardCopy.type, handleReportHardcopy);
  yield takeLatest(actions.raiseDispute.type, handleRaiseDispute);
  yield takeEvery(actions.downloadFile.type, handlePurchaseOrderDownload);
  yield takeLatest(actions.addGRN.type, handleAddGRN);
  yield takeLatest(actions.updateGRNDetails, handleUpdateGRN);
  yield takeLatest(
    actions.fetchCompanyFeatures.type,
    handleFetchCompanyFeatures
  );
  yield takeLatest(actions.fetchCommodities.type, handleFetchCommodities);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchDistricts.type, handleFetchDistricts);
  yield takeLatest(actions.fetchSamplers.type, handleFetchSamplers);
  yield takeLatest(actions.updateOrderStatus.type, handleUpdateOrderStatus);
  yield takeLatest(actions.fetchDropdown.type, handleFetchDropdown);
  yield takeLatest(actions.fetchProjectCodes.type, handleFetchProjectCodes);
  yield takeLatest(
    actions.createReplacementOrder.type,
    handleCreateReplacementOrder
  );
  yield takeLatest(actions.fetchCompanies.type, handleFetchCompanies);
  yield takeLatest(
    actions.updateLabsAndLogistics.type,
    handleUpdateLabsAndLogistics
  );
  yield takeLatest(actions.updateSampleDetails.type, handleUpdateSampleDetails);
  yield takeLatest(actions.requestCorrection.type, handleRequestCorrection);
  yield takeLatest(actions.fetchCommentsRequest.type, handleFetchComments);
  yield takeLatest(actions.fetchLabs.type, handleFetchLabs);
  yield takeLatest(
    actions.fetchLogisticPartners.type,
    handleFetchLogisticPartners
  );
  yield takeLatest(
    actions.assignLabAndLogistic.type,
    handleAssignLabAndLogistic
  );
  yield takeLatest(actions.fetchSectors.type, handleFetchSectors);

  yield takeLatest(
    actions.fetchLabAnalyticsDetails.type,
    handleFetchLabAnalyticsDetails
  );
  yield takeEvery(actions.updateOrderDocuments.type, handleUpdateOrderDocuments);
  yield takeLatest(actions.fetchOrderCorrectionReasons.type, handleFetchOrderCorrectionReasons);
  yield takeEvery(actions.requestOrderCorrection.type, handleRequestOrderCorrection);
  yield takeLatest(actions.fetchPackages.type, handleFetchPackages);
  yield takeEvery(actions.updateOrderDetails.type, handleUpdateOrderDetails);
  yield takeLatest(actions.fetchAgencies.type, handleFetchAgencies);

}
